import 'core-js/features/object/assign';
import 'core-js/features/string/repeat';
import 'core-js/features/string/pad-start';
import 'core-js/features/string/pad-end';
import 'core-js/features/global-this';  // https://github.com/uNmAnNeR/imaskjs/issues/300

import Drawer from '../classes/Drawer';
import Popover from '../classes/Popover';
import Checkout from '../classes/Checkout';
import axios from 'axios';
import SlimSelect from 'slim-select'
import Swiper from 'swiper';
import swal from 'sweetalert';
import simpleParallax from 'simple-parallax-js';
import {NSerializeJson} from "nserializejson";
import IMask from 'imask';
import Accordion from 'accordion-js';
import GLightbox from 'glightbox';

//import {TweenLite, TimelineMax, TweenMax, Power1, Linear} from 'gsap/TweenMax';
//import {TimelineMax, Power1} from "gsap/all";

import {TweenMax, TimelineMax, Power1} from "gsap/all";
import ScrollMagic from 'scrollmagic';
//import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
 
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default class Common {

    constructor() {      
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        window.axios = axios;

        window.addEventListener('scroll', ()=>{
            this.toggleHeader();
        });

        window.addEventListener('click', ()=>{
            this.closeDropdown();
        });

        this.drawer = new Drawer();
        this.checkout = new Checkout();

        document.getElementById('btnNav').addEventListener('click', function() {
            this.classList.toggle('active');
            document.getElementById('overlay').classList.toggle('open');
        });

        this.live('button.scroll','click', (event,target) => {
            window.scrollBy(0,window.innerHeight/2);
        });

        this.live('button[data-drawer]','click', (event,target) => {
            this.drawer.open(target);
        });

        this.live('button[data-popover-target]','click', (event,target) => {
            let popover = new Popover(target, {position:'top'});
            popover.toggle()
        });

        this.live('select[data-cart-qty]','change', (event,target) => {
            const uid = target.getAttribute('data-cart-qty'),
                  qty = target.value,
                  inject = this.getClosest(target,".swiper-slide");
            this.checkout.updateQty(uid,qty,inject);
        });

        this.live('button[data-cart-remove]','click', (event,target) => {
            const uid = target.getAttribute('data-cart-remove'),
                  inject = this.getClosest(target,".swiper-slide");
            this.checkout.remove(uid,inject);
        });

        this.live('.dropdown','click', (event,target) => {
            this.toggleDropdown(event,target);
        });

        this.live('button.clearCart','click', (event,target) => {
            const inject = this.getClosest(target,".swiper-slide");
            this.checkout.empty(inject);
        });

        this.live('select[data-url]','change', (event,target) => {
            const url = target.getAttribute('data-url'),
                  inject = target.getAttribute('data-target'),
                  val = target.value;
            if(url && inject){
                axios.post(url,{val}).then(function (response) {
                    document.querySelector(inject).slim.setData(response.data);
                })
            }
        });

        this.live('input[name="paymentType"]','change', (event,target) => {
            if(document.querySelector('input[name="paymentType"]:checked').value=='cc'){
                document.getElementById("creditCardFormWrapper").style.display = 'block';
            }else {
                document.getElementById("creditCardFormWrapper").style.display = 'none';
            }
            [...document.querySelectorAll('input[name="paymentType"]')].forEach((el)=>{
                el.parentElement.classList.remove('selected');
            });
            target.parentElement.classList.add('selected');
        });

        this.live('input[name="invoiceType"]','change', (event,target) => {
            if(document.querySelector('input[name="invoiceType"]:checked').value=='personal'){
                document.getElementById("corporateCustomerWrapper").style.display = 'none';
                document.getElementById("personalCustomerWrapper").style.display = 'block';
            }else {
                document.getElementById("personalCustomerWrapper").style.display = 'none';
                document.getElementById("corporateCustomerWrapper").style.display = 'block';
            }
        });

        this.live('input[name="diffInvAddress"]','change', (event,target) => {
            if(document.querySelector('input[name="diffInvAddress"]:checked') && document.querySelector('input[name="diffInvAddress"]:checked').value=='1'){
                document.getElementById("invAddress").style.display = 'block';
            }else {
                document.getElementById("invAddress").style.display = 'none';
                axios.post("./checkout/pickinvoiceaddress",{"uid":0});
            }
        });

        this.live('#deliveryAddress','change', (event,target) => {
            const uid = document.getElementById('deliveryAddress').value;
            if(uid) {
                axios.post("./checkout/pickaddress",{uid}).then((response)=>{
                    if(response.data.content){
                        document.getElementById("deliveryDatePicker").innerHTML = response.data.content;
                        this.init(document.getElementById("deliveryDatePicker"));
                    }
                    if(response.data.js && typeof response.data.js == 'object'){
                        response.data.js.forEach((script)=>{
                            (new Function(script)).call(response.data);
                        });
                    }
                });
            }
        });

        this.live('#invoiceAddress','change', (event,target) => {
            const uid = document.getElementById('invoiceAddress').value;
            if(uid) {
                axios.post("./checkout/pickinvoiceaddress",{uid}).then((response)=>{
                    if(response.data.js && typeof response.data.js == 'object'){
                        response.data.js.forEach((script)=>{
                            (new Function(script)).call(response.data);
                        });
                    }
                });
            }
        });

        this.live('input[name="deliveryDay"]','change', (event,target) => {
            const day = document.querySelector('input[name="deliveryDay"]:checked').value;

            [...document.querySelectorAll('input[name="deliveryDay"]')].forEach((el)=>{
                el.parentElement.classList.remove('selected');
            });
            target.parentElement.classList.add('selected');

            axios.post("./checkout/pickday",{day}).then((response)=>{
                if(response.data.content){
                    document.getElementById("deliveryDatePicker").innerHTML = response.data.content;
                    this.init(document.getElementById("deliveryDatePicker"));
                }
                if(response.data.js && typeof response.data.js == 'object'){
                    response.data.js.forEach((script)=>{
                        (new Function(script)).call(response.data);
                    });
                }
            });
        });

        this.live('#deliveryHour','change', (event,target) => {
            const hour = document.getElementById('deliveryHour').value;
            axios.post("./checkout/pickhour",{hour}).then((response)=>{
                if(response.data.content){
                    document.getElementById("deliveryDatePicker").innerHTML = response.data.content;
                    this.init(document.getElementById("deliveryDatePicker"));
                }
                if(response.data.js && typeof response.data.js == 'object'){
                    response.data.js.forEach((script)=>{
                        (new Function(script)).call(response.data);
                    });
                }
            });
        });

        
        this.live('.addToFavourite','click', (event,target) => {
            const uid = target.getAttribute('data-uid');
            if(uid) {
                axios.post("./account/addtofavourite",{uid}).then((response)=>{
                    if(response.data.js && typeof response.data.js == 'object'){
                        response.data.js.forEach((script)=>{
                            (new Function(script)).call(response.data);
                        });
                    }
                });
            }
        });
        
        
        this.live('[data-toogle-id][data-toggle-target]','click', (event, target) => {
            const _itemid = target.getAttribute('data-toogle-id');
            const _target = target.getAttribute('data-toggle-target');
            document.querySelectorAll('[data-toggle-item="' + _itemid + '"]').forEach(item => {
                item.style.display = 'none';
            })
            document.querySelector(_target).removeAttribute('style');
            
            if(target.classList.contains('tab-button')){
                target.closest('ul').querySelectorAll('li').forEach(item => {
                    item.classList.remove('active');
                })
                target.closest('li').classList.add('active');
            }
        });
        

        //document.querySelectorAll('input[name="invoiceType"]')

        this.live('form.ajax','submit', (event,target) => {
            event.preventDefault();

            //this.serialize(target),
            let data = NSerializeJson.serializeForm(target),
                inject = target.getAttribute('data-inject');

            if(inject && document.querySelector(inject)){
                document.querySelector(inject).innerHTML = '<p><i class="ion ion-load-a icon-is-spinning"></i> Lütfen bekleyiniz...</p>';
            }

            axios.post(target.action,data).then(function (response) {
                if(inject && document.querySelector(inject) && response.data.content){
                    document.querySelector(inject).innerHTML = response.data.content;
                }
                if(response.data.body){
                    document.body.innerHTML = response.data.body;
                }
                if(response.data.js && typeof response.data.js == 'object'){
                    response.data.js.forEach((script)=>{
                        (new Function(script)).call(target,data);
                    });
                }
            }).catch(function (error) {
                swal("Hata!", "Bilinmeyen bir hata oluştu!", "error");
            });
        });

        document.querySelector('body').addEventListener('click', (event) => {
            if(event.target.classList.contains('bodyoverlay')){
                if(document.getElementById("uzayModal")){
                    document.getElementById("uzayModal").remove();
                }
                this.drawer.close();
            }
        });

        this.live('#closeSidebar','click', (event,target) => {
            this.drawer.close();
        });

        [...document.querySelectorAll('.detailContent img')].forEach(element => {
            element.parentNode.classList.add("imgHover");
            const wrapper = document.createElement('div');
            wrapper.classList.add('inner');
            element.parentNode.insertBefore(wrapper, element);
            wrapper.appendChild(element);

            //const orgx = element.parentNode.innerHTML;
            //const newx = "<div class='inner'>" + element + "</div>";
            //element.parentNode.innerHTML = newx;
        });
    }

    init(element) {
        [...element.querySelectorAll("select.select")].forEach((element)=>{
            let opts = {select: element, showSearch: false};
            if(element.getAttribute('data-search')){
                opts.showSearch = true;
                opts.searchPlaceholder = "Ara...";
            }
            if(element.getAttribute('data-source') && window.App[element.getAttribute('data-source')]){
                opts.data = window.App[element.getAttribute('data-source')];
            }
            setTimeout(function(){new SlimSelect(opts);}, 100);
        });

        [...element.querySelectorAll("input[type=radio]")].forEach((element)=>{
            element.addEventListener("change",(element)=>{
                if(element.target.parentElement.classList.contains('customRadio')){
                    [...document.querySelectorAll('input[name='+element.target.name+']')].forEach((el)=>{
                        el.parentElement.classList.remove('selected');
                    });
                    element.target.parentElement.classList.add('selected');
                }
            });
        });

        [...element.querySelectorAll(".swiperSlider")].forEach((element)=>{
            new Swiper(element, {
                slidesPerView: parseInt(element.getAttribute('data-swiper-spv')||1),
                init: true,
                spaceBetween: parseInt(element.getAttribute('data-swiper-sb')||0),
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            });
        });

        [...element.querySelectorAll("input[data-mask]")].forEach((element)=>{
            let opts = {lazy: false};
            opts.mask = element.getAttribute('data-mask');
            new IMask(element, opts);
        });

        if(element.querySelector('.ac-container')){
            var accordion = new Accordion('.ac-container');
        }

        if(element.querySelector('.glightbox')){
            var lightbox = GLightbox();
            /*window.lightbox.setElements([{
                'href': element.querySelector('.lightbox').getAttribute('href'),
                'type': 'image'
            }]);*/
            lightbox.open(element.querySelector('.glightbox'));
        }

        const images = document.querySelectorAll('.ulayout:not(.vertical) img');
        new simpleParallax(images, {
            scale: 1.15,
            delay: .6,
            transition: 'cubic-bezier(0,0,0,1)'
        });

        this.initAnimations();
    }

    initAnimations()
    {
        const scrollbutton = document.querySelector('button.scroll'),
            scrollArrow = scrollbutton.querySelectorAll('button.scroll img'),
            tlScrollButton = new TimelineMax({repeat: -1, repeatDelay: .2, yoyo: false});

        tlScrollButton.staggerFrom(scrollArrow, .5, {autoAlpha: 0, x: '+=18', ease: Power1.easeOut}, .2);

        const controller = new ScrollMagic.Controller();

        [...document.querySelectorAll('.ulayout:not(.vertical)')].forEach(layout => {
            let items = layout.querySelectorAll('.content ul li:not(.title)');
            if(items.length){
                let timeline = new TimelineMax();

                timeline.staggerFromTo(items, 0.3, {x: 20, autoAlpha:0, ease: Power1.easeNone}, {x:0, autoAlpha:1}, 0.1, 0);

                new ScrollMagic.Scene({
                    triggerElement: layout,
                    triggerHook: 0.6
                })
                .setTween(timeline)
                .addTo(controller);
            }
        });

        [...document.querySelectorAll('.ulayout:not(.vertical)')].forEach(layout => {
            let item = layout.querySelector('.content a.link');
            if(item){
                let timeline = new TimelineMax();

                timeline.fromTo(item, 0.5, {x: 20, autoAlpha: 0}, {x:0, autoAlpha:1}, 0);

                new ScrollMagic.Scene({
                    triggerElement: layout,
                    triggerHook: 0.7
                })
                .setTween(timeline)
                .addTo(controller);
            }
        })
    }

    finalize(element) {
        document.body.classList.remove('loading');
    }

    toggleHeader() {
        if(window.scrollY>0){
            document.querySelector('header').classList.add('collapsed');
            document.getElementById('overlay').classList.add('collapsed');
        }else {
            document.querySelector('header').classList.remove('collapsed');
            document.getElementById('overlay').classList.remove('collapsed');
        }
    }
    
    toggleDropdown(e,target) {
        e.stopPropagation();
        var menu = target.nextSibling;

        while(menu && menu.nodeType != 1) {
            menu = menu.nextSibling
        }
        if(!menu) return;
        
        if (menu.style.display !== 'block') {
            menu.style.display = 'block';
        }  else {
            menu.style.display = 'none';
        }
    }

    closeDropdown() {
        [...document.querySelectorAll(".dropdown-menu")].forEach((element)=>{
            element.style.display = 'none';
        });
    }

    live (selector, event, handler) {
        document.addEventListener(event, function(evt){
            var target = evt.target;
            while (target != null){
                var isMatch = target.matches(selector);
                
                if (isMatch){
                    evt.stopImmediatePropagation();
                    handler(evt,target);
                    return false;
                }
                
                target = target.parentElement;
            }
        },true);
    }

    serialize (form) {
        let serialized = {};

        for (var i = 0; i < form.elements.length; i++) {
            var field = form.elements[i];
            
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

            if (field.type === 'select-multiple') {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized[encodeURIComponent(field.name)] = encodeURIComponent(field.options[n].value);
                }
            } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized[encodeURIComponent(field.name)] = encodeURIComponent(field.value);
            }
        }

        return serialized;
    }
    
    post(href, data) {
        axios.post(href, data).then(function (response) {
            if(response.data.js && typeof response.data.js == 'object'){
                response.data.js.forEach((script)=>{
                    (new Function(script)).call();
                });
            }
        }).catch(function (error) {
            swal("Hata!", "Bilinmeyen bir hata oluştu!", "error");
        });
    }

    getClosest(elem, selector) {
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    //while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                };
        }

        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;
    }
}